const RouteUpdateConstants = {
  ROUTE_UPDATE: "routeUpdate/routeUpdate"
};
export {
  RouteUpdateConstants as default
};
//# sourceMappingURL=RouteUpdateConstants.js.map
